export default "__VITE_ASSET__B2q$G6Wq__"